var searchBoxBuilder1=true;

document.addEventListener('DOMSubtreeModified', function () {

  if(searchBoxBuilder1 && document.querySelector('.gs__btn-nav-link') !=null){

   
    Array.from(document.querySelectorAll('.gs__btn-nav-link')).forEach(link => {

    if(link.textContent=="Altersprüfung"){
 searchBoxBuilder1=false;
      link.style.display = 'none'; 
    }
});
  }

});
  if(typeof best_option!=="undefined" &&(
    
    
    
    best_option.product.description.toLowerCase().indexOf("prosecco")!="-1" || 
     best_option.product.description.toLowerCase().indexOf("bier")!="-1" || 
     best_option.product.description.toLowerCase().indexOf("wein")!="-1" || 
     best_option.product.description.toLowerCase().indexOf("alkohol")!="-1" || 
     best_option.product.description.toLowerCase().indexOf("sekt")!="-1" || 
     best_option.product.description.toLowerCase().indexOf("schnaps")!="-1" || 
    best_option.product.description.toLowerCase().indexOf("champagner")!="-1")){
    
    document.querySelector(".add-to-cart").style.visibility = 'hidden'; 


    document.querySelector("button.shopify-payment-button__button").style.visibility = 'hidden'; 

   var div = document.createElement('div');
    div.innerHTML="<span style='margin-top:10px' class='validage "+document.querySelector(".add-to-cart").classList.toString()+"'>"+document.querySelector(".add-to-cart").textContent+"</span>";
    
    document.querySelector(".add-to-cart").parentElement.append(div);


    
   var div = document.createElement('div');
 
      div.innerHTML="<span style='margin-top: 10px;font-weight:600' class='validagepay "+document.querySelector(".add-to-cart").classList.toString()+"'>"+document.querySelector(".shopify-payment-button__button").textContent+"</span>";
    
    document.querySelector(".shopify-payment-button__button").parentElement.append(div);
  
  document.querySelector('.validage').addEventListener('click', function(e) {
  
  if(document.querySelector('.validage-bg')){
    document.querySelector('.validage-bg').remove();
  }else{

  div = document.createElement('div');
 div.innerHTML='  <div class="validage-bg" style="position: fixed; top: 0px; left: 0px; height: 100%; width: 100%; z-index: 999998; background: rgba(0, 0, 0, 0.39);"></div>';
  document.querySelector("body").append(div);  
  div = document.createElement('div');
 div.innerHTML='  <div class="validage-box" style="position: fixed; top: 80px; width: 100%; max-width: 710px; z-index: 9999799; background: rgb(255, 255, 255); text-align: center; left: 50%; line-height: 25px; transform: translate(-50%, 0%); padding: 25px;"><span class="validage-close" style="cursor:pointer;    position: absolute;     top: 5px;     right: 10px;     font-size: 20px; "> <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="styles__closeIcon--dF-qj [object Object]"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.78507 10.8457L17.6863 18.747L18.7469 17.6863L10.8457 9.78509L18.7469 1.88389L17.6863 0.823227L9.78507 8.72443L1.88387 0.823227L0.823212 1.88389L8.72441 9.78509L0.823212 17.6863L1.88387 18.747L9.78507 10.8457Z" fill="#171E4A"></path></svg></span>Für dieses Produkt müssen Sie und der Empfänger mindestens 18 Jahre alt sein. <br>Sind Sie und der Empfänger mindestens 18 Jahre alt?<br>                 <span style="  padding: 10px;    border: 1px solid;    margin: 20px;    display: inline-block;    min-width: 100px;cursor:pointer" id="validageyes">Ja</span><span id="validageno" style="  padding: 10px;    border: 1px solid;    margin: 20px;    display: inline-block;    min-width: 100px;cursor:pointer">Nein</span> </div>';

    document.querySelector("body").append(div);  


  
  }

var deleteLinks = document.querySelectorAll('.validage-bg, .validage-close, #validageno');

Array.from(deleteLinks).forEach(link => {
    link.addEventListener('click', function(event) {
           document.querySelector('.validage-bg').remove();
       document.querySelector('.validage-box').remove();
    });
});


var deleteLinks = document.querySelectorAll('#validageyes');

Array.from(deleteLinks).forEach(link => {
    link.addEventListener('click', function(event) {
           document.querySelector('.validage-bg').remove();
       document.querySelector('.validage-box').remove();
      document.querySelector(".add-to-cart").click();
    });
});
    
  
  
  

  });

      document.querySelector('.validagepay').addEventListener('click', function(e) {
  
  if(document.querySelector('.validage-bg')){
    document.querySelector('.validage-bg').remove();
  }else{

  div = document.createElement('div');
 div.innerHTML='  <div class="validage-bg" style="position: fixed; top: 0px; left: 0px; height: 100%; width: 100%; z-index: 999998; background: rgba(0, 0, 0, 0.39);"></div>';
  document.querySelector("body").append(div);  
  div = document.createElement('div');
 div.innerHTML='  <div class="validage-box" style="position: fixed; top: 80px; width: 100%; max-width: 710px; z-index: 9999799; background: rgb(255, 255, 255); text-align: center; left: 50%; line-height: 25px; transform: translate(-50%, 0%); padding: 25px;"><span class="validage-close" style="cursor:pointer;    position: absolute;     top: 5px;     right: 10px;     font-size: 20px; "> <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="styles__closeIcon--dF-qj [object Object]"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.78507 10.8457L17.6863 18.747L18.7469 17.6863L10.8457 9.78509L18.7469 1.88389L17.6863 0.823227L9.78507 8.72443L1.88387 0.823227L0.823212 1.88389L8.72441 9.78509L0.823212 17.6863L1.88387 18.747L9.78507 10.8457Z" fill="#171E4A"></path></svg></span>Für dieses Produkt müssen Sie und der Empfänger mindestens 18 Jahre alt sein. <br>Sind Sie und der Empfänger mindestens 18 Jahre alt?<br>                 <span style="  padding: 10px;    border: 1px solid;    margin: 20px;    display: inline-block;    min-width: 100px;cursor:pointer" id="validageyes">Ja</span><span id="validageno" style="  padding: 10px;    border: 1px solid;    margin: 20px;    display: inline-block;    min-width: 100px;cursor:pointer">Nein</span> </div>';

    document.querySelector("body").append(div);  


  
  }

var deleteLinks = document.querySelectorAll('.validage-bg, .validage-close, #validageno');

Array.from(deleteLinks).forEach(link => {
    link.addEventListener('click', function(event) {
           document.querySelector('.validage-bg').remove();
       document.querySelector('.validage-box').remove();
    });
});


var deleteLinks = document.querySelectorAll('#validageyes');

Array.from(deleteLinks).forEach(link => {
    link.addEventListener('click', function(event) {
           document.querySelector('.validage-bg').remove();
       document.querySelector('.validage-box').remove();
      document.querySelector(".shopify-payment-button__button").click();
    });
});
    
  
  
  

  });
  
    
  }















//Box Builder 
var isAlk=false;
var searchBoxBuilder=true;



document.addEventListener('DOMSubtreeModified', function () {
  let inVarenkorb = 0;

  if(searchBoxBuilder && document.querySelector('.gs__btn-nav-submit') !=null && document.querySelector("#gsStackTheme").getAttribute("data-step-id")==6){
 searchBoxBuilder=false;
    





    var products=JSON.parse(localStorage.getItem("gsBuilderItems_888"));
    
Array.from(products.items).forEach((product,i) => {
  if(typeof product.product!="undefined"){
   

var tags=product.product.tags;
    console.log(tags);





    tags= tags.map(v => v.toLowerCase());
  
      if(tags.includes("prosecco") ||
         tags.includes("bier") ||
         tags.includes("wein") ||
         tags.includes("alkohol") ||
         tags.includes("sekt") ||
         tags.includes("schnaps") ||
          tags.includes("champagner") 
        ){
        
        console.log(document.querySelector(".gs__btn-nav-submit").classList.toString());
           document.querySelector(".gs__btn-nav-submit").style.display = 'none'; 

  if( i == 0 ){
    console.log('work');
      var button = document.createElement('button');
            button.classList="boxage gs__btn";
            button.textContent=document.querySelector(".gs__btn-nav-submit").textContent;
      }
      
      
      if( button ){
      document.querySelector(".gs__btn-nav-submit").parentElement.append(button);
      button.addEventListener('click', function(e) {
              
        if(document.querySelector('.validage-bg')){
          document.querySelector('.validage-bg').remove();
        }else{


    //todo add secound check if customer removes some articles


    
  div = document.createElement('div');
 div.innerHTML='  <div class="validage-bg" style="position: fixed; top: 0px; left: 0px; height: 100%; width: 100%; z-index: 999998; background: rgba(0, 0, 0, 0.39);"></div>';
  document.querySelector("body").append(div);  

  div = document.createElement('div');
 div.innerHTML='  <div class="validage-box" style="position: fixed; top: 80px; width: 100%; max-width: 710px; z-index: 9999799; background: rgb(255, 255, 255); text-align: center; left: 50%; line-height: 25px; transform: translate(-50%, 0%); padding: 25px;"><span class="validage-close" style="cursor:pointer;    position: absolute;     top: 5px;     right: 10px;     font-size: 20px; "> <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="styles__closeIcon--dF-qj [object Object]"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.78507 10.8457L17.6863 18.747L18.7469 17.6863L10.8457 9.78509L18.7469 1.88389L17.6863 0.823227L9.78507 8.72443L1.88387 0.823227L0.823212 1.88389L8.72441 9.78509L0.823212 17.6863L1.88387 18.747L9.78507 10.8457Z" fill="#171E4A"></path></svg></span>Für dieses Produkt müssen Sie und der Empfänger mindestens 18 Jahre alt sein. <br>Sind Sie und der Empfänger mindestens 18 Jahre alt?<br>                 <span style="  padding: 10px;    border: 1px solid;    margin: 20px;    display: inline-block;    min-width: 100px;cursor:pointer" id="validageyes">Ja</span><span id="validageno" style="  padding: 10px;    border: 1px solid;    margin: 20px;    display: inline-block;    min-width: 100px;cursor:pointer">Nein</span> </div>';

    document.querySelector("body").append(div);  


  
  }
var deleteLinks = document.querySelectorAll('.validage-bg, .validage-close, #validageno');

Array.from(deleteLinks).forEach(link => {
    link.addEventListener('click', function(event) {
           document.querySelector('.validage-bg').remove();
       document.querySelector('.validage-box').remove();
    });
});


var deleteLinks = document.querySelectorAll('#validageyes');

Array.from(deleteLinks).forEach(link => {
    link.addEventListener('click', function(event) {
      console.log('yes');
      if(document.querySelector('.validage-bg') !== null){
        document.querySelector('.validage-bg').remove();
      }
           
       document.querySelector('.validage-box').remove();
      document.querySelector(".gs__btn-nav-submit").disabled = false;
      document.querySelector(".gs__btn-nav-submit").click();
    });
});



  

});
      }




        
      }
    
  }
 
});
    
  }

});












